export * from './common.translate.loader';
export * from './translate.manager';
export * from './translate.utils';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/translate/index.ts